import { render, staticRenderFns } from "./TopBarSecond.vue?vue&type=template&id=45a252c7&scoped=true&xmlns%3Av-popover=true"
import script from "./TopBarSecond.vue?vue&type=script&lang=js"
export * from "./TopBarSecond.vue?vue&type=script&lang=js"
import style0 from "./TopBarSecond.vue?vue&type=style&index=0&id=45a252c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a252c7",
  null
  
)

export default component.exports